import { useMutation } from "@apollo/client";
import { UPDATE_TASK } from "../../graphql/mutations/ProjectEditContext";

// eslint-disable-next-line import/prefer-default-export
export const useUpdateTask = () => {
  const [mutation, { data, error, loading }] = useMutation(UPDATE_TASK);

  const updateTask = async ({ projectId, taskId, parentTaskId, insertAfterTaskId, task }) => {
    const variables = {
      updateTaskParams: {
        projectId,
        taskId,
        parentTaskId,
        insertAfterTaskId,
      },
      task,
    };

    const res = await mutation({ variables });

    return res?.data?.projects?.updateTask;
  };

  return [updateTask, { data, error, loading }];
};
